export default "__VITE_ASSET__BLu52NTq__"